import { render } from "./AiReport.vue?vue&type=template&id=d2adbaae&scoped=true"
import script from "./AiReport.vue?vue&type=script&lang=js"
export * from "./AiReport.vue?vue&type=script&lang=js"

import "./AiReport.vue?vue&type=style&index=0&id=d2adbaae&scoped=true&lang=scss"
import "./AiReport.vue?vue&type=style&index=1&id=d2adbaae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2adbaae"]])

export default __exports__